import React from 'react';
import PropTypes, { any } from 'prop-types';

import PlayerCardWrapper from '../PlayerCard/PlayerCardWrapper';
import CardContentV3 from './CardContentV3';
import withAuth from '../../hocs/withAuth';

const PlayerCardV3 = (props) => {
    const {
        addOptionsSpace,
        auth,
        inactive,
        isCurrentMemberAdmin,
        isSelected,
        menuOnSelected,
        menuOptions,
        onSelectClick,
        optionSpaceContent,
        player,
        sendMessage,
        showActionRequiredBackground,
        showCheckbox,
        showSeeProfileLink,
        showPosition,
        highlightCard,
        showSaveBookmark,
        'data-testid': dataTestId,
    } = props;

    const {
        id,
        playerId,
        memberId,
        isPro,
    } = player;

    const isCurrentUser = auth?.user?.id === memberId;

    const isMemberAllowedToMessage = !!memberId && !isCurrentUser && ((isPro && isCurrentMemberAdmin) || !isPro);

    const enableMessaging = (!!sendMessage && !inactive && !showSeeProfileLink && isMemberAllowedToMessage);

    return (
        <PlayerCardWrapper
            link={!showSeeProfileLink ? `/profiles/${id || playerId}` : null}
            actionRequired={showActionRequiredBackground}
            inactive={inactive}
            eventProfileV3
            highlightCard={highlightCard}
        >
            <CardContentV3
                addOptionsSpace={addOptionsSpace}
                enableMessaging={enableMessaging}
                isCurrentMemberAdmin={isCurrentMemberAdmin}
                isSelected={isSelected}
                menuOptions={menuOptions}
                onMenuSelected={menuOnSelected}
                onMessageClick={() => sendMessage(player)}
                onSelectClick={onSelectClick}
                optionSpaceContent={optionSpaceContent}
                player={player}
                showCheckbox={showCheckbox}
                showSeeProfileLink={showSeeProfileLink}
                showPosition={showPosition}
                showSaveBookmark={showSaveBookmark && !isCurrentUser}
                data-testid={dataTestId}
            >
                {props.children}
            </CardContentV3>
        </PlayerCardWrapper>
    );
};

PlayerCardV3.propTypes = {
    addOptionsSpace: PropTypes.bool,
    auth: PropTypes.objectOf(any).isRequired,
    inactive: PropTypes.bool,
    isCurrentMemberAdmin: PropTypes.bool,
    isSelected: PropTypes.bool,
    menuOnSelected: PropTypes.func,
    menuOptions: PropTypes.arrayOf(any),
    onSelectClick: PropTypes.func,
    optionSpaceContent: PropTypes.string,
    player: PropTypes.objectOf(any).isRequired,
    sendMessage: PropTypes.func,
    showActionRequiredBackground: PropTypes.bool,
    showCheckbox: PropTypes.bool,
    showSeeProfileLink: PropTypes.bool,
    showPosition: PropTypes.bool,
    highlightCard: PropTypes.bool,
    showSaveBookmark: PropTypes.bool,
    'data-testid': PropTypes.string,
};

PlayerCardV3.defaultProps = {
    addOptionsSpace: false,
    inactive: false,
    isCurrentMemberAdmin: false,
    isSelected: false,
    menuOnSelected: () => { },
    menuOptions: null,
    onSelectClick: () => { },
    optionSpaceContent: '',
    sendMessage: () => { },
    showActionRequiredBackground: false,
    showCheckbox: false,
    showSeeProfileLink: false,
    showPosition: false,
    highlightCard: false,
    showSaveBookmark: false,
    'data-testid': null,
};

export default withAuth(PlayerCardV3);
